// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f03f4308","400":"56a2ee09","455":"64c11568"}[chunkId] + ".chunk.js";
};